export function pixelsToDataUrl(
  pixels: number[][],
  palette: string[],
  maxSize = 128,
  secondaryColors?: string[]        // NEW: valfri sekundär palett
): string {
  if (!pixels?.length || !palette?.length) return '';
  const pH = pixels.length;
  const pW = pixels[0].length;
  const scale = Math.max(1, Math.floor(Math.min(maxSize / pW, maxSize / pH)));
  const w = pW * scale, h = pH * scale;

  const cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  const ctx = cv.getContext('2d');
  if (!ctx) return '';
  ctx.imageSmoothingEnabled = false;

  const resolveColor = (ci: number): string => {
    const isSec = (ci & 0x80) !== 0 || ci < 0;                 // 128..143 eller -16..-1
    const base = ci < 0 ? (ci + 16) & 0x0f : (ci & 0x0f);      // 0..15
    if (isSec) {
      const sec = secondaryColors ?? palette;
      return sec[base] ?? palette[base] ?? '#000';
    }
    return palette[base] ?? '#000';
  };

  for (let y = 0; y < pH; y++) {
    for (let x = 0; x < pW; x++) {
      const ci = pixels[y][x] ?? 0;
      ctx.fillStyle = resolveColor(ci);
      ctx.fillRect(x * scale, y * scale, scale, scale);
    }
  }
  return cv.toDataURL('image/png');
}